export const newsItems = [
  // ============ 娱乐新闻 ============
  {
    id: "ent-1001",
    category: "entertainment",
    title: "年度盛典红毯造型盘点：这些高光瞬间凭什么刷屏热搜",
    excerpt: "今年的年度盛典红毯可以说是近年最有话题度的一届，从复古宫廷风到极简未来感，造型团队各出奇招，一夜之间多个词条冲上热搜榜。",
    content: [
      "今年的年度盛典红毯可以说是近年最有话题度的一届。从下午开始，场馆外的粉丝应援就已经把周边道路围得水泄不通，社交平台上的讨论热度也随着第一位嘉宾的出场被彻底点燃。",
      "整体来看，今年的造型走出了两个截然不同的方向。一部分艺人选择了复古宫廷风，重工的刺绣、缎面长裙搭配精致的盘发，把红毯仪式感拉满；另一部分则偏爱极简未来感，利落的廓形剪裁配上金属质感的配饰，靠气场取胜。",
      "造型团队之间的较量其实是红毯背后真正的看点。一位不愿具名的造型师透露，一套红毯造型从选定到最终呈现，往往要经过三轮以上的试装与调整，甚至连鞋跟高度、走位节奏都会提前彩排。",
      "值得注意的是，今年“可持续时尚”的概念被更多提及。有艺人选择穿着二手高定礼服，或以环保材质定制的礼服亮相，向公众传递理性消费的理念，也收获了不少正向评价。",
      "红毯终究只是序章。真正决定一位艺人一整年口碑的，仍然是作品本身。当聚光灯散去，观众记住的，往往还是那个在镜头前拿出真诚表达的人。",
    ],
    cover: "https://readdy.ai/api/search-image?query=elegant%20red%20carpet%20awards%20ceremony%20stage%20with%20warm%20golden%20spotlights%20and%20glamorous%20spotlight%20atmosphere%2C%20editorial%20photography%2C%20rich%20warm%20tones&width=800&height=600&seq=ent-redcarpet-01&orientation=landscape",
    source: "51吃瓜娱乐",
    author: "编辑部",
    publishedAt: "2026-10-15 09:30",
    views: 128400,
    tags: ["年度盛典红毯", "星闻速递", "时尚"],
  },
  {
    id: "ent-1002",
    category: "entertainment",
    title: "新剧开播首周收视登顶：这部现实题材凭什么打动年轻观众",
    excerpt: "没有流量堆砌、没有狗血反转，一部聚焦普通职场与家庭生活的现实题材剧集，却在开播首周就拿下同档期收视第一。",
    content: [
      "没有流量堆砌、没有狗血反转，一部聚焦普通职场与家庭生活的现实题材剧集，却在开播首周就拿下了同档期收视第一。",
      "剧集最打动人的地方，是它对“普通人的难”给予了足够诚实的呈现。加班到深夜却错过末班车的疲惫、面对长辈催婚时的无力、租房搬家时的一地鸡毛，这些细节都让观众在弹幕里刷出一句“这就是我”。",
      "导演在采访中表示，创作团队前期做了大量真实采访，把几十位普通人的故事揉进了剧本，目的就是让角色“立得住”。也正因如此，剧中的每一次冲突都显得克制而真实。",
      "从市场反馈来看，观众对悬浮剧情的耐心确实在下降。真实、共情、有温度的叙事，正在成为现实题材突围的关键。这也给行业提了个醒：好故事永远比流量更持久。",
    ],
    cover: "https://readdy.ai/api/search-image?query=cozy%20modern%20living%20room%20scene%20with%20warm%20lamp%20light%20and%20soft%20neutral%20tones%2C%20cinematic%20still%20framing%2C%20intimate%20atmosphere&width=800&height=600&seq=ent-drama-02&orientation=landscape",
    source: "51吃瓜娱乐",
    author: "文娱观察",
    publishedAt: "2026-10-14 20:10",
    views: 98300,
    tags: ["新剧开播", "现实题材", "收视"],
  },
  {
    id: "ent-1003",
    category: "entertainment",
    title: "演唱会门票一票难求 主办方回应加场与实名制新规",
    excerpt: "本轮巡演开票后几乎秒空，二手平台溢价现象再度引发热议。主办方近日回应，将通过加场与强化实名核验等方式缓解购票难题。",
    content: [
      "本轮巡演开票后几乎秒空，二手平台上的溢价现象再度引发热议。主办方近日就购票难问题作出回应。",
      "据主办方介绍，团队正与场馆协商增加场次，并计划在部分城市启用更强的实名核验机制，购票人与入场人信息需一致，转赠功能也将受到限制，以压缩黄牛的套利空间。",
      "业内人士分析，热门演出供不应求是长期存在的结构性矛盾。技术手段能一定程度抑制炒作，但更根本的解决方式，仍是增加优质演出的有效供给。",
      "对普通观众而言，官方渠道优先、理性看待溢价，或许是目前最稳妥的选择。行业也期待更透明的票务机制能尽快落地，让热爱不再被高价拦在门外。",
    ],
    cover: "https://readdy.ai/api/search-image?query=vibrant%20concert%20arena%20with%20colorful%20stage%20lights%20and%20crowd%20silhouettes%2C%20energetic%20live%20music%20atmosphere%2C%20warm%20amber%20glow&width=800&height=600&seq=ent-concert-03&orientation=landscape",
    source: "51吃瓜娱乐",
    author: "演出前线",
    publishedAt: "2026-10-14 15:45",
    views: 76200,
    tags: ["演唱会门票", "演出市场", "实名制"],
  },
  {
    id: "ent-1004",
    category: "entertainment",
    title: "综艺名场面盘点：这一季真正出圈的是“真实感”",
    excerpt: "没有剧本痕迹的即兴互动、嘉宾之间自然发生的化学反应，让这一季的综艺意外收获了口碑与热度的双丰收。",
    content: [
      "综艺市场向来竞争激烈，但这一季有一档节目凭借“真实感”稳稳出了圈。",
      "节目组在制作上做了一次减法：减少刻意设置的矛盾任务，把更多镜头留给嘉宾之间自然发生的互动。于是观众看到了笨拙却真诚的照顾、看到了意见不合后如何和解，也看到了成年人之间难得的松弛。",
      "有观众评论说，看这档节目像在看朋友聚会，没有压迫感。这种“陪伴感”，恰恰是当下碎片化娱乐里稀缺的东西。",
      "从数据看，节目相关片段的二次创作在短视频平台持续发酵，多个名场面梗被反复玩味。真实的情绪，永远比精心设计的剧情更有传播力。",
    ],
    cover: "https://readdy.ai/api/search-image?query=bright%20cozy%20tv%20studio%20set%20with%20warm%20pastel%20decor%20and%20soft%20lighting%2C%20cheerful%20relaxed%20atmosphere%2C%20clean%20modern%20editorial%20style&width=800&height=600&seq=ent-variety-04&orientation=landscape",
    source: "51吃瓜娱乐",
    author: "综艺观察",
    publishedAt: "2026-10-13 18:20",
    views: 64800,
    tags: ["综艺名场面", "口碑综艺", "真实感"],
  },
  {
    id: "ent-1005",
    category: "entertainment",
    title: "科幻大片定档消息公布 概念美术首度公开引期待",
    excerpt: "备受关注的科幻电影正式公布定档信息，同步释出的概念美术物料展现了宏大的世界观设定，让影迷直呼“等太久了”。",
    content: [
      "备受关注的科幻电影正式公布定档信息，同步释出的概念美术物料，迅速登上多个平台的热议榜单。",
      "从公开的物料来看，影片构建了一个层次丰富的未来世界：悬浮城市、深空航行、机械生命的伦理困境，视觉风格既有硬核科技感，也保留了东方美学的留白意境。",
      "主创团队透露，为了呈现更可信的科幻质感，制作组在物理模拟与场景搭建上投入了大量时间，仅一场太空戏的分镜就打磨了数月。",
      "近年来，国产科幻在叙事与工业水准上持续进步。这部作品能否延续这一势头，成为年末档期的一大看点。",
    ],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20futuristic%20space%20city%20concept%20art%20with%20dramatic%20lighting%20and%20deep%20orange%20blue%20contrast%2C%20epic%20sci-fi%20atmosphere&width=800&height=600&seq=ent-scifi-05&orientation=landscape",
    source: "51吃瓜娱乐",
    author: "电影频道",
    publishedAt: "2026-10-13 11:05",
    views: 88900,
    tags: ["科幻大片", "定档", "概念美术"],
  },
  {
    id: "ent-1006",
    category: "entertainment",
    title: "音乐现场回归热潮 独立乐队小场馆巡演一票难求",
    excerpt: "相比大型体育馆，越来越多乐迷开始青睐小场馆的近距离演出。独立乐队的巡演门票在开售当天便售罄，现场氛围被反复点赞。",
    content: [
      "音乐现场正在回归。相比大型体育馆，越来越多乐迷开始青睐小场馆的近距离演出，独立乐队的巡演门票往往在开售当天便售罄。",
      "小场馆的魅力在于“近”。舞台与观众几乎没有距离，一个眼神、一次即兴的加演，都能立刻得到回应。这种双向的在场感，是线上收听永远替代不了的体验。",
      "多支乐队在接受采访时表示，小场馆巡演更能检验作品的完成度，也更容易和听众建立真实的连接。不少乐队还会在演后留下来与歌迷交流。",
      "对城市而言，活跃的现场演出也在悄悄改变着夜间的文化生态。Livehouse 周边的小店、深夜食堂，因演出日而变得热闹，一条独特的城市夜生活动线正在成形。",
    ],
    cover: "https://readdy.ai/api/search-image?query=intimate%20small%20live%20music%20venue%20with%20warm%20stage%20lighting%20and%20close%20audience%2C%20moody%20amber%20tones%2C%20authentic%20live%20atmosphere&width=800&height=600&seq=ent-live-06&orientation=landscape",
    source: "51吃瓜娱乐",
    author: "音乐现场",
    publishedAt: "2026-10-12 21:40",
    views: 54300,
    tags: ["音乐现场", "独立乐队", "巡演"],
  },
  {
    id: "ent-1007",
    category: "entertainment",
    title: "访谈节目回暖：慢节奏对话为何重新被年轻人喜欢",
    excerpt: "在快节奏的短视频时代，一档近乎“慢直播”的访谈节目意外走红，嘉宾之间长达一小时的深聊，成为不少人睡前的内容陪伴。",
    content: [
      "在快节奏的短视频时代，一档近乎“慢直播”的访谈节目却意外走红。",
      "节目里没有抢答题，也很少有刻意的冲突，取而代之的是嘉宾之间长达一小时的自然对谈。有人聊职业焦虑，有人聊原生家庭，也有人只是安静地讲了讲自己喜欢的书。",
      "不少观众表示，这类节目成了睡前的“电子布洛芬”。在信息过载的一天结束后，听别人慢慢说话，本身就是一种放松。",
      "内容行业的一个有趣信号是：当速食内容趋于饱和，愿意提供“深度陪伴”的产品反而更容易建立长期黏性。慢，也许是一种更聪明的快。",
    ],
    cover: "https://readdy.ai/api/search-image?query=minimal%20cozy%20podcast%20interview%20setting%20with%20warm%20wood%20tones%20and%20soft%20lamp%20light%2C%20calm%20intimate%20editorial%20mood&width=800&height=600&seq=ent-talk-07&orientation=landscape",
    source: "51吃瓜娱乐",
    author: "内容观察",
    publishedAt: "2026-10-12 10:15",
    views: 42700,
    tags: ["访谈节目", "慢节奏", "内容趋势"],
  },
  {
    id: "ent-1008",
    category: "entertainment",
    title: "国潮品牌联名热潮再起 传统文化如何玩出新意",
    excerpt: "从非遗纹样到古典色彩，国潮品牌与传统文化 IP 的联名一波接一波。当“国潮”成为常态，品牌比拼的其实是理解文化的深度。",
    content: [
      "从非遗纹样到古典色彩，国潮品牌与传统文化 IP 的联名一波接一波，成为消费市场里持续升温的风景。",
      "不过，当“国潮”从新鲜概念变成常态打法，真正的分水岭也随之出现。简单把传统元素贴在包装上的做法，越来越难打动挑剔的年轻人。",
      "做得好的品牌，往往先沉下心去理解文化本身。有团队专程去拜访手艺人，把传统工艺的步骤拆解重组；也有品牌把古典配色做成整套视觉系统，让联名不止停留在图案层面。",
      "文化的价值不在于被消费，而在于被理解与再创造。当品牌愿意把诚意放进细节里，国潮才不会沦为一阵风。",
    ],
    cover: "https://readdy.ai/api/search-image?query=modern%20chinese%20style%20product%20display%20with%20traditional%20pattern%20accents%20and%20warm%20red%20gold%20palette%2C%20clean%20editorial%20still%20life&width=800&height=600&seq=ent-guochao-08&orientation=landscape",
    source: "51吃瓜娱乐",
    author: "消费观察",
    publishedAt: "2026-10-11 16:30",
    views: 39600,
    tags: ["国潮品牌", "传统文化", "联名"],
  },
  {
    id: "ent-1009",
    category: "entertainment",
    title: "短剧出海成绩亮眼 内容本土化成关键胜负手",
    excerpt: "多部国产短剧在海外平台取得不错的数据表现。业内认为，真正拉开差距的不是制作规模，而是对当地观众口味的理解。",
    content: [
      "近期，多部国产短剧在海外平台取得了不错的数据表现，让“短剧出海”再度成为行业热词。",
      "和长剧不同，短剧的节奏更快、钩子更密，这既是它天然的优势，也意味着它必须迅速抓住观众。业内的共识是：能否做好本土化，是决定成败的关键。",
      "成功的案例往往在剧本阶段就做了本地化改编，从人物设定到情感逻辑，都尽量贴近目标市场的文化语境，而不是简单翻译后直接上线。",
      "出海不是一次性的生意，而是一场对内容理解力的长期考验。谁能更真诚地尊重不同文化，谁就更有可能走得更远。",
    ],
    cover: "https://readdy.ai/api/search-image?query=smartphone%20filming%20short%20video%20scene%20with%20warm%20ring%20light%20and%20modern%20studio%20background%2C%20clean%20contemporary%20editorial%20look&width=800&height=600&seq=ent-shortdrama-09&orientation=landscape",
    source: "51吃瓜娱乐",
    author: "行业前沿",
    publishedAt: "2026-10-11 09:50",
    views: 33500,
    tags: ["短剧出海", "内容本土化", "行业"],
  },
  {
    id: "ent-1010",
    category: "entertainment",
    title: "秋冬穿搭趋势发布 温暖大地色成为今年主旋律",
    excerpt: "时尚机构发布的最新趋势报告显示，今年秋冬的流行关键词是“松弛”与“温暖”，低饱和的大地色系占据了绝对主流。",
    content: [
      "时尚机构发布的最新趋势报告显示，今年秋冬的流行关键词是“松弛”与“温暖”。",
      "配色上，低饱和的大地色系占据主流：燕麦、焦糖、栗棕、雾灰，这些容易被忽略的颜色，恰好构成了最有质感的基础盘。搭配上则强调宽松廓形与层次叠穿，兼顾风度与温度。",
      "有趣的是，报告提到“耐穿性”成为消费者关注的第三大因素，仅次于版型与价格。人们越来越愿意为一件能穿很多年的衣服买单，而不是追逐一季就过时的款式。",
      "穿搭的本质是表达。当潮流退去，留在衣柜里的，往往是那些既舒服又耐看的单品。",
    ],
    cover: "https://readdy.ai/api/search-image?query=autumn%20winter%20fashion%20flatlay%20with%20warm%20earthy%20tone%20knitwear%20and%20neutral%20accessories%2C%20soft%20natural%20light%2C%20minimal%20editorial%20style&width=800&height=600&seq=ent-fashion-10&orientation=landscape",
    source: "51吃瓜娱乐",
    author: "时尚频道",
    publishedAt: "2026-10-10 14:20",
    views: 28900,
    tags: ["秋冬穿搭", "时尚趋势", "大地色"],
  },

  // ============ 社会热点 ============
  {
    id: "soc-2001",
    category: "society",
    title: "城市夜经济回暖：深夜街头的小店为何越来越多",
    excerpt: "入秋以来，多个城市的夜间消费明显升温。深夜食堂、24 小时书店、深夜市集的出现，正悄悄改变着城市的夜晚。",
    content: [
      "入秋以来，多个城市的夜间消费明显升温。深夜食堂、24 小时书店、深夜市集的出现，正悄悄改变着城市的夜晚。",
      "走访中我们发现，夜经济的回暖和“人”的需求变化紧密相关。年轻人下班晚、通勤远，一顿热乎的宵夜、一家亮着灯的书店，成了他们安放疲惫的地方。",
      "与此同时，政策层面的支持也在跟进。不少城市延长了公共交通运营时间，对夜间经营的小店给予租金与审批上的便利，让“深夜的烟火气”有了持续生长的土壤。",
      "专家提醒，夜经济不能只追求“热闹”，还要兼顾周边居民的休息与安全。有秩序、有温度的街区，才能让夜生活真正可持续。",
    ],
    cover: "https://readdy.ai/api/search-image?query=warm%20cozy%20city%20street%20at%20night%20with%20glowing%20small%20shops%20and%20soft%20amber%20lights%2C%20lively%20yet%20intimate%20urban%20evening%20atmosphere&width=800&height=600&seq=soc-night-01&orientation=landscape",
    source: "51吃瓜社会",
    author: "城市观察",
    publishedAt: "2026-10-15 08:40",
    views: 112000,
    tags: ["城市夜经济", "民生", "夜间消费"],
  },
  {
    id: "soc-2002",
    category: "society",
    title: "社区食堂悄然兴起 一餐热饭托起家门口的幸福",
    excerpt: "近年来，越来越多的社区食堂开到了居民楼下。它不仅解决了老年人的吃饭难题，也意外成了邻里之间重新熟络起来的地方。",
    content: [
      "近年来，越来越多的社区食堂开到了居民楼下。它不仅解决了老年人的吃饭难题，也意外成了邻里之间重新熟络起来的地方。",
      "和传统食堂不同，新型社区食堂更注重“家”的感觉：菜品以家常菜为主，价格亲民，座位安排也刻意宽松，鼓励居民坐下来慢慢吃、慢慢聊。",
      "一位常来用餐的老人告诉我们，以前一个人在家常常随便应付一顿，如今每天下楼吃饭，还能和老邻居说说话，日子一下子有了盼头。",
      "社区虽小，却是社会治理最基础的单元。一顿热饭背后，是公共服务向“最后一百米”延伸的诚意，也是城市温度的具象化。",
    ],
    cover: "https://readdy.ai/api/search-image?query=cozy%20community%20dining%20hall%20with%20warm%20wooden%20tables%20and%20friendly%20atmosphere%2C%20soft%20daylight%2C%20clean%20warm%20editorial%20photography&width=800&height=600&seq=soc-canteen-02&orientation=landscape",
    source: "51吃瓜社会",
    author: "民生频道",
    publishedAt: "2026-10-14 17:20",
    views: 87600,
    tags: ["社区暖心故事", "民生", "社区食堂"],
  },
  {
    id: "soc-2003",
    category: "society",
    title: "非遗手艺人走进直播间 老手艺找到新观众",
    excerpt: "吹糖人、竹编、扎染……曾经担心无人传承的老手艺，正通过直播间被更多年轻人看见。镜头另一端，是手艺与时代的一次握手。",
    content: [
      "吹糖人、竹编、扎染……曾经担心无人传承的老手艺，正通过直播间被更多年轻人看见。",
      "对不少手艺人来说，直播最初只是无奈之举——线下客流减少，只能尝试线上。没想到镜头一开，评论区里涌来的好奇与赞叹，让他们重新找到了被需要的成就感。",
      "更让人欣慰的是，一些年轻观众看完直播后开始主动了解、甚至拜师学艺。有手艺人的徒弟，就是从直播间的弹幕里走出来的。",
      "传承从来不是把老东西原封不动地锁进橱窗，而是让它重新回到生活中被使用、被喜爱。直播间或许只是一个小小的窗口，却照见了老手艺新的可能。",
    ],
    cover: "https://readdy.ai/api/search-image?query=traditional%20chinese%20handicraft%20workshop%20with%20bamboo%20weaving%20and%20warm%20natural%20light%2C%20artisanal%20texture%2C%20cozy%20editorial%20photography&width=800&height=600&seq=soc-craft-03&orientation=landscape",
    source: "51吃瓜社会",
    author: "文化民生",
    publishedAt: "2026-10-14 10:05",
    views: 65400,
    tags: ["非遗手艺人", "传统文化", "直播"],
  },
  {
    id: "soc-2004",
    category: "society",
    title: "地铁通勤时间缩短 一条新线路如何改变一座城",
    excerpt: "新开通的地铁线路让不少通勤族的上班时间明显缩短。对一座城市而言，轨道交通的延伸，往往意味着生活半径的重新丈量。",
    content: [
      "新开通的地铁线路，让不少通勤族的上班时间明显缩短。有人算了一笔账：每天来回能省下将近一小时，一年下来就是十几天的自由时间。",
      "轨道交通带来的改变远不止通勤。沿线新开的商铺、更活跃的租房市场、被“拉近”的城市两端，都在悄悄重塑着居民的生活方式。",
      "当然，便利的背后也有新的课题：早高峰的拥挤、换乘的动线设计、末班车时间的衔接，都需要在实践中不断优化。",
      "一条线路，丈量的不只是距离，更是一座城市对普通人时间的尊重。让人少在路上奔波一点，就是实实在在的民生改善。",
    ],
    cover: "https://readdy.ai/api/search-image?query=modern%20clean%20subway%20station%20interior%20with%20warm%20lighting%20and%20sleek%20architecture%2C%20calm%20urban%20commuter%20atmosphere&width=800&height=600&seq=soc-metro-04&orientation=landscape",
    source: "51吃瓜社会",
    author: "城市观察",
    publishedAt: "2026-10-13 15:30",
    views: 59300,
    tags: ["地铁通勤", "城市交通", "民生"],
  },
  {
    id: "soc-2005",
    category: "society",
    title: "山区支教老师的十年：把课堂搬进了孩子的世界",
    excerpt: "一位支教老师在大山里待了整整十年。她说，自己教的不只是课本知识，更想让孩子们知道，山的那一边，还有更大的世界。",
    content: [
      "一位支教老师在大山里待了整整十年。她说，自己教的不只是课本知识，更想让孩子们知道，山的那一边还有更大的世界。",
      "十年里，她带着学生读诗、画画、做科学小实验，也把外面的见闻讲给孩子们听。许多曾经沉默寡言的孩子，慢慢变得愿意表达、敢于做梦。",
      "让她最欣慰的，是学生们一个个走出了大山。有人考上了大学，有人回到家乡成了新的老师，把这份光继续传了下去。",
      "教育的意义，或许就在于用一个人的坚持，点亮一群人的可能。这样的故事，值得被更多人看见。",
    ],
    cover: "https://readdy.ai/api/search-image?query=warm%20sunlit%20rural%20classroom%20with%20wooden%20desks%20and%20soft%20golden%20light%2C%20hopeful%20educational%20atmosphere%2C%20editorial%20photography&width=800&height=600&seq=soc-teacher-05&orientation=landscape",
    source: "51吃瓜社会",
    author: "人物报道",
    publishedAt: "2026-10-12 19:10",
    views: 71200,
    tags: ["暖心故事", "教育", "人物"],
  },
  {
    id: "soc-2006",
    category: "society",
    title: "电动车充电安全再引关注 小区加装设施成共识",
    excerpt: "随着电动车保有量上升，充电安全成为社区治理的重点话题。越来越多的小区开始加装集中充电设施，从源头减少安全隐患。",
    content: [
      "随着电动车保有量持续上升，充电安全成为社区治理的重点话题。越来越多的小区开始加装集中充电设施。",
      "此前，“飞线充电”“入户充电”等行为存在较大的安全风险。集中充电棚的出现，既提供了规范、便捷的充电场所，也通过智能断电、烟感报警等技术手段，从源头降低了隐患。",
      "不过，设施的落地也需要居民的理解与配合。有社区通过议事会征集意见，把充电棚的位置、数量交由居民共同决定，既提高了使用率，也减少了矛盾。",
      "安全无小事。让便捷与安全并存，需要管理者的用心，也需要每一位居民的自觉。",
    ],
    cover: "https://readdy.ai/api/search-image?query=clean%20modern%20residential%20courtyard%20with%20organized%20parking%20area%20and%20warm%20daylight%2C%20tidy%20urban%20community%20scene&width=800&height=600&seq=soc-charge-06&orientation=landscape",
    source: "51吃瓜社会",
    author: "民生频道",
    publishedAt: "2026-10-12 11:30",
    views: 45800,
    tags: ["社区治理", "安全", "民生"],
  },
  {
    id: "soc-2007",
    category: "society",
    title: "“15 分钟生活圈”落地观察：便利店、菜场与公园的距离",
    excerpt: "走出家门 15 分钟，能买菜、能就医、能散步，是不少城市正在努力实现的目标。生活圈的完善程度，正成为衡量宜居的新标尺。",
    content: [
      "走出家门 15 分钟，能买菜、能就医、能散步——这是不少城市正在努力实现的目标。",
      "“15 分钟生活圈”听起来简单，落地却需要精密的规划：菜场、便利店的密度要合理，社区医院、养老站点要够近，口袋公园和健身步道也要随处可见。",
      "一些试点社区的做法是把闲置空间盘活利用：边角地块改造成小微绿地，废弃车棚变成便民服务站，让有限的土地发挥出更大的公共价值。",
      "宜居从来不是宏大叙事的堆砌，而是藏在每天买菜的几步路、散步的那片树荫里。生活圈的完善，正是城市对普通人日常的温柔回应。",
    ],
    cover: "https://readdy.ai/api/search-image?query=charming%20walkable%20neighborhood%20street%20with%20small%20shops%20greenery%20and%20warm%20daylight%2C%20livable%20urban%20community%20atmosphere&width=800&height=600&seq=soc-lifecircle-07&orientation=landscape",
    source: "51吃瓜社会",
    author: "城市观察",
    publishedAt: "2026-10-11 14:00",
    views: 38900,
    tags: ["生活圈", "城市治理", "宜居"],
  },
  {
    id: "soc-2008",
    category: "society",
    title: "秋招观察：年轻人择业更看重“成长感”",
    excerpt: "秋季招聘进入高峰，一份关于求职偏好的调查显示，相比薪资数字，越来越多年轻人把“能不能学到东西”放到了更靠前的位置。",
    content: [
      "秋季招聘进入高峰，一份关于求职偏好的调查显示，薪资之外，年轻人越来越看重“成长感”。",
      "调查中提到，稳定的学习机会、清晰的发展路径、以及能带来成就感的项目，成为求职者评价一份工作的重要维度。有受访者直言，比起一开始就拿高薪，更怕“待在原地不动”。",
      "与此同时，求职者的信息获取方式也在变化。更多年轻人习惯通过真实员工的分享、行业访谈来判断一家公司，而不是只看招聘广告。",
      "就业市场的成熟，体现在供需两端都更理性。当年轻人敢于为自己的成长做长远打算，其实是一种难得的清醒。",
    ],
    cover: "https://readdy.ai/api/search-image?query=bright%20modern%20coworking%20space%20with%20warm%20daylight%20and%20young%20people%20working%2C%20hopeful%20professional%20atmosphere%2C%20clean%20editorial%20style&width=800&height=600&seq=soc-job-08&orientation=landscape",
    source: "51吃瓜社会",
    author: "职场频道",
    publishedAt: "2026-10-10 16:45",
    views: 52100,
    tags: ["秋招", "就业", "职场"],
  },
  {
    id: "soc-2009",
    category: "society",
    title: "老旧小区改造进行时：从“改房子”到“改生活”",
    excerpt: "加装电梯、翻新管网、增设停车位……老旧小区改造不只是修修补补，更是在重新安排居民的生活方式。",
    content: [
      "加装电梯、翻新管网、增设停车位……老旧小区改造，正从“改房子”走向“改生活”。",
      "和新建小区不同，老旧小区的改造难点在于“众口难调”。一部电梯能不能装、装在哪里，往往需要反复协商。有社区通过成立居民议事小组，让每一户的声音都被听见。",
      "改造完成后，变化是肉眼可见的：老人不用再爬楼梯，雨天不再内涝，小区里多了儿童活动的场地。这些看似微小的改善，直接影响着居民的幸福感。",
      "城市更新不是大拆大建，而是对既有生活空间的精心修补。把人放在中心，改造才有真正的意义。",
    ],
    cover: "https://readdy.ai/api/search-image?query=freshly%20renovated%20old%20residential%20building%20courtyard%20with%20greenery%20and%20warm%20sunlight%2C%20renewed%20urban%20community%20scene&width=800&height=600&seq=soc-renovation-09&orientation=landscape",
    source: "51吃瓜社会",
    author: "民生频道",
    publishedAt: "2026-10-09 10:20",
    views: 41300,
    tags: ["老旧小区", "城市更新", "民生"],
  },
  {
    id: "soc-2010",
    category: "society",
    title: "无偿献血志愿者群像：平凡人做着不平凡的坚持",
    excerpt: "在城市的一角，有一群定期献血的普通人。他们不善言辞，却用一年又一年的坚持，默默守护着陌生人的生命。",
    content: [
      "在城市的一角，有一群定期献血的普通人。他们不善言辞，却用一年又一年的坚持，默默守护着陌生人的生命。",
      "有人坚持了十多年，献血证攒了厚厚一叠；有人把自己的经历做成科普，帮助更多人消除对献血的误解；也有人只是在某个下午走进献血车，从此成了常客。",
      "血站的医生告诉我们，稳定的无偿献血者是临床用血的重要保障。他们每一次的举手之劳，可能就是一个家庭的重燃希望。",
      "善良不需要惊天动地。正是这些平凡人的默默付出，让一座城市多了一份抵御风险的底气。",
    ],
    cover: "https://readdy.ai/api/search-image?query=clean%20bright%20community%20volunteer%20service%20scene%20with%20warm%20daylight%20and%20caring%20atmosphere%2C%20hopeful%20editorial%20photography&width=800&height=600&seq=soc-blood-10&orientation=landscape",
    source: "51吃瓜社会",
    author: "人物报道",
    publishedAt: "2026-10-08 15:00",
    views: 35600,
    tags: ["志愿者", "暖心故事", "公益"],
  },

  // ============ 网络趣闻 ============
  {
    id: "net-3001",
    category: "netfun",
    title: "猫咪“上班”记：一只网红橘猫如何治愈一座办公楼",
    excerpt: "写字楼里来了一只流浪橘猫，物业本想请它离开，没想到它凭一己之力成了整栋楼最受欢迎的“员工”。",
    content: [
      "写字楼里来了一只流浪橘猫。物业本想请它离开，没想到它凭一己之力，成了整栋楼最受欢迎的“员工”。",
      "橘猫很快摸索出了自己的“工作日程”：早上蹲在大堂看人来人往，中午蹭到茶水间撒娇换零食，下午则雷打不动地占据前台的最佳观景位打盹。",
      "最神奇的是它的“情绪安抚”功能。有员工说，赶项目忙到崩溃时，蹲下来撸两分钟猫，心情就能平复不少。渐渐地，午休撸猫成了大家的默契。",
      "如今，这只橘猫有了自己的名字和专属工牌，还有同事轮流给它准备口粮。一只不期而遇的猫，让冷冰冰的办公楼多了一点柔软的联结。",
    ],
    cover: "https://readdy.ai/api/search-image?query=adorable%20orange%20tabby%20cat%20lounging%20in%20a%20bright%20modern%20office%20lobby%20with%20warm%20sunlight%2C%20cozy%20cheerful%20atmosphere&width=800&height=600&seq=net-cat-01&orientation=landscape",
    source: "51吃瓜趣闻",
    author: "趣闻小组",
    publishedAt: "2026-10-15 10:10",
    views: 156000,
    tags: ["宠物日常", "治愈", "萌宠"],
  },
  {
    id: "net-3002",
    category: "netfun",
    title: "大学生宿舍改造计划：6 平米里的生活美学",
    excerpt: "一张床、一张桌、一点预算，一群大学生把狭小的宿舍改造成了让人羡慕的样子。他们的口号是：房子是租的，但生活不是。",
    content: [
      "一张床、一张桌、一点预算，一群大学生把狭小的宿舍改造成了让人羡慕的样子。",
      "改造的思路其实不复杂：重新规划收纳，把高频物品放在伸手可及的地方；用一块好看的桌布和几盏暖光小灯，营造出温馨的氛围；再添一盆绿植，让空间立刻有了生气。",
      "有人还会把改造过程拍成短视频，分享给同样住在宿舍的同学。评论区里最常见的一句话是：“原来 6 平米也能住得这么舒服。”",
      "生活的质感，很多时候和面积无关，而在于愿不愿意花一点心思。认真对待自己每天待着的空间，本身就是一种温柔。",
    ],
    cover: "https://readdy.ai/api/search-image?query=cozy%20small%20dorm%20room%20makeover%20with%20warm%20string%20lights%20plants%20and%20tidy%20desk%2C%20inviting%20aesthetic%20interior&width=800&height=600&seq=net-dorm-02&orientation=landscape",
    source: "51吃瓜趣闻",
    author: "生活趣闻",
    publishedAt: "2026-10-14 13:25",
    views: 92400,
    tags: ["校园趣事", "宿舍改造", "生活美学"],
  },
  {
    id: "net-3003",
    category: "netfun",
    title: "大爷的公园健身图鉴：这些“硬核操作”让人自愧不如",
    excerpt: "你以为公园健身只是散步遛弯？那可就小看大爷大妈们了。单杠、太极、抖空竹，十八般武艺样样精通。",
    content: [
      "你以为公园健身只是散步遛弯？那可就小看大爷大妈们了。",
      "清晨的公园里，单杠上翻转腾挪的身影、广场上整齐划一的太极方阵、角落里把空竹抖出花样的老人，构成了最具生命力的画面。有年轻人试着自己上单杠，才做了两个就“败下阵来”。",
      "这些“硬核健身”背后，是日复一日的坚持。一位大爷说，自己每天来公园锻炼已经十多年，风雨无阻，“身体是练出来的，不是躺出来的”。",
      "看公园里的他们，你会觉得年龄或许真的只是个数字。保持热爱、坚持运动，原来可以让人活得这么有劲头。",
    ],
    cover: "https://readdy.ai/api/search-image?query=energetic%20elderly%20people%20exercising%20in%20a%20sunny%20park%20with%20green%20trees%20and%20warm%20morning%20light%2C%20healthy%20vibrant%20atmosphere&width=800&height=600&seq=net-park-03&orientation=landscape",
    source: "51吃瓜趣闻",
    author: "趣闻小组",
    publishedAt: "2026-10-14 08:50",
    views: 78100,
    tags: ["公园健身", "生活趣闻", "全民运动"],
  },
  {
    id: "net-3004",
    category: "netfun",
    title: "外卖备注里的隐形诗人：那些让人会心一笑的干饭需求",
    excerpt: "“不要香菜，多给点饭，谢谢老板”“辣椒多一点，我今天需要被治愈”……外卖备注，成了打工人一片小小的表达天地。",
    content: [
      "“不要香菜，多给点饭，谢谢老板”“辣椒多一点，我今天需要被治愈”——外卖备注，成了打工人一片小小的表达天地。",
      "有商家会把有趣的备注截图分享出来，引来一大片共鸣。有人用备注和店家聊天，有人写下一句无厘头的话逗乐后厨，也有人认真地请求“今天心情不好，请帮我加个蛋”。",
      "一位从业多年的骑手说，备注里的这些小心思，常常能让奔波的一天多出一点暖意。“有些话看着就好笑，送单路上都会忍不住笑出来。”",
      "在快节奏的生活里，一句认真的备注，就是平凡人对平凡人的一次善意投递。生活虽累，但总有人在缝隙里藏了点温柔。",
    ],
    cover: "https://readdy.ai/api/search-image?query=warm%20cozy%20takeout%20food%20packaging%20on%20a%20wooden%20table%20with%20steam%20and%20soft%20daylight%2C%20appetizing%20homely%20atmosphere&width=800&height=600&seq=net-delivery-04&orientation=landscape",
    source: "51吃瓜趣闻",
    author: "生活趣闻",
    publishedAt: "2026-10-13 12:15",
    views: 66700,
    tags: ["打工人日常", "外卖", "生活趣闻"],
  },
  {
    id: "net-3005",
    category: "netfun",
    title: "爷爷辈的“潮玩”收藏：老相机、老唱片里的时光故事",
    excerpt: "在年轻人追捧潮玩的同时，一些老年人也有自己的“收藏癖”。老相机、黑胶唱片、老邮票，每一件背后都藏着一段旧时光。",
    content: [
      "在年轻人追捧潮玩的同时，一些老年人也有自己的“收藏癖”。",
      "一位退休教师收藏了三十多台老相机，每一台都能说出它的来历和时代故事；另一位老人则把年轻时的黑胶唱片整整齐齐地保存至今，还能哼出每一首的旋律。",
      "他们说，收藏的不是物件，而是记忆。翻看这些老物件，就像重新走了一趟自己的人生。有晚辈听得入迷，索性把老人的讲述录了下来，做成了一份特别的家庭档案。",
      "潮流会更替，但属于每个人的时光，都值得被温柔收藏。旧物里的故事，有时比新品更动人。",
    ],
    cover: "https://readdy.ai/api/search-image?query=vintage%20camera%20and%20vinyl%20records%20collection%20on%20warm%20wooden%20shelf%20with%20soft%20nostalgic%20lighting%2C%20retro%20editorial%20still%20life&width=800&height=600&seq=net-collect-05&orientation=landscape",
    source: "51吃瓜趣闻",
    author: "趣闻小组",
    publishedAt: "2026-10-12 16:40",
    views: 52300,
    tags: ["收藏", "怀旧", "生活趣闻"],
  },
  {
    id: "net-3006",
    category: "netfun",
    title: "菜市场里的“隐藏菜单”：摊主们的吆喝藏着生活智慧",
    excerpt: "逛菜市场不只是买菜，更是一场热气腾腾的现场演出。摊主们各具特色的吆喝与沟通，让人隔着屏幕都能感受到烟火气。",
    content: [
      "逛菜市场不只是买菜，更是一场热气腾腾的现场演出。",
      "摊主们各有一套经营智慧：有人凭一句押韵的吆喝吸引顾客，有人懂得根据顾客的表情推荐菜品，还有人会在秤上悄悄多放两把葱，换一句“下次还来”。",
      "有博主专门拍摄菜市场的日常，把摊主们的金句整理成“隐藏菜单”，意外收获了大量点赞。网友们说，看这些视频特别解压，仿佛闻到了新鲜的烟火味。",
      "菜市场是城市最真实的切片。在这里，人与人之间的信任与热络，被一斤一两地认真称量着。",
    ],
    cover: "https://readdy.ai/api/search-image?query=vibrant%20fresh%20vegetable%20market%20stall%20with%20colorful%20produce%20and%20warm%20daylight%2C%20lively%20lifelike%20atmosphere%2C%20editorial%20photography&width=800&height=600&seq=net-market-06&orientation=landscape",
    source: "51吃瓜趣闻",
    author: "生活趣闻",
    publishedAt: "2026-10-11 09:35",
    views: 48900,
    tags: ["菜市场", "烟火气", "生活趣闻"],
  },
  {
    id: "net-3007",
    category: "netfun",
    title: "把阳台变成小花园：都市人的迷你“绿野仙踪”",
    excerpt: "不需要大院子，一个几平米的阳台，也能种出四季。越来越多的都市人开始在方寸之间，经营属于自己的绿色小天地。",
    content: [
      "不需要大院子，一个几平米的阳台，也能种出四季。",
      "从香草、多肉到小番茄，都市人在阳台上尝试着各式各样的种植。有人把塑料瓶改造成花盆，有人用旧木箱搭出立体菜架，把有限的空间利用到了极致。",
      "种花种菜最大的收获，往往不是收成，而是过程。浇水、松土、看着嫩芽一天天长大，那种被治愈的感觉，是刷手机换不来的。",
      "在钢铁森林里拥有一小片绿意，是对忙碌生活的一次温柔抵抗。哪怕只是一盆薄荷，也能让日子多一点生机。",
    ],
    cover: "https://readdy.ai/api/search-image?query=lush%20cozy%20balcony%20garden%20with%20potted%20plants%20herbs%20and%20warm%20sunlight%2C%20inviting%20urban%20green%20oasis%2C%20editorial%20photography&width=800&height=600&seq=net-balcony-07&orientation=landscape",
    source: "51吃瓜趣闻",
    author: "生活趣闻",
    publishedAt: "2026-10-10 15:20",
    views: 43200,
    tags: ["阳台种植", "都市生活", "生活趣闻"],
  },
  {
    id: "net-3008",
    category: "netfun",
    title: "方言挑战赛刷屏：一句家乡话，勾起无数人的乡愁",
    excerpt: "一场方言挑战在社交平台火了起来。天南海北的网友用最亲切的口音介绍家乡，评论区里全是“听着就想家了”。",
    content: [
      "一场方言挑战在社交平台火了起来。天南海北的网友用最亲切的口音介绍家乡，评论区里全是“听着就想家了”。",
      "有人用方言念诗，有人翻唱家乡的民谣，还有人认真科普方言里那些难以翻译的精妙表达。南腔北调汇聚在一起，热闹又亲切。",
      "不少离家的年轻人表示，平时在外地说普通话，很久没听到家乡话了，突然在手机上刷到，眼眶一下就热了。",
      "方言里藏着一个人的来处。当熟悉的腔调重新响起，那份对故土的眷恋，也就被轻轻唤醒了。",
    ],
    cover: "https://readdy.ai/api/search-image?query=colorful%20map%20of%20dialect%20regions%20on%20a%20warm%20wooden%20desk%20with%20soft%20daylight%2C%20nostalgic%20cultural%20editorial%20style&width=800&height=600&seq=net-dialect-08&orientation=landscape",
    source: "51吃瓜趣闻",
    author: "趣闻小组",
    publishedAt: "2026-10-09 14:10",
    views: 39800,
    tags: ["方言", "乡愁", "网络热点"],
  },
  {
    id: "net-3009",
    category: "netfun",
    title: "图书馆里的“自习搭子”：陌生人的默契陪伴",
    excerpt: "不知道从什么时候起，“自习搭子”成了年轻人的新社交方式。素不相识的人因为共同的努力，成了彼此最安静的陪伴。",
    content: [
      "不知道从什么时候起，“自习搭子”成了年轻人的新社交方式。",
      "在图书馆、自习室，两个甚至一群互不相识的人，因为共同的努力目标坐到一起。他们不常交谈，只是默契地互不打扰，在专注的氛围里彼此支撑。",
      "有学生说，一个人学习容易懈怠，但看到对面的人还在坚持，自己也不好意思停下来。这种无声的鼓励，比任何鸡汤都管用。",
      "成年人的友谊，有时不需要太多言语。一个共同的目标，一段安静的陪伴，就已经足够温暖。",
    ],
    cover: "https://readdy.ai/api/search-image?query=quiet%20warm%20library%20study%20area%20with%20wooden%20desks%20and%20soft%20window%20light%2C%20focused%20calm%20atmosphere%2C%20editorial%20photography&width=800&height=600&seq=net-study-09&orientation=landscape",
    source: "51吃瓜趣闻",
    author: "校园趣事",
    publishedAt: "2026-10-08 11:45",
    views: 36400,
    tags: ["自习搭子", "校园趣事", "年轻人"],
  },
  {
    id: "net-3010",
    category: "netfun",
    title: "街角修表匠的四十年：在方寸之间守护时间的精度",
    excerpt: "一把镊子、一个放大镜、一张工作台，老师傅在街角修了四十年表。在他看来，修表修的不只是时间，更是一份信任。",
    content: [
      "一把镊子、一个放大镜、一张工作台，老师傅在街角修了四十年表。",
      "在智能手表普及的今天，机械表的维修显得有些“慢”。但老师傅说，越是这样，越要把手艺守住。一块表拆解开有上百个零件，每一个都要小心对待。",
      "来修表的顾客中，有不少是拿着父辈甚至祖辈的旧表。对这些人来说，这块表承载的早已不只是时间，而是一段无法替代的回忆。",
      "在这个追求效率的时代，愿意为一件小事慢下来的人，反而格外珍贵。老师傅修好的，或许不仅是表，更是人们心里那份对“认真”的敬意。",
    ],
    cover: "https://readdy.ai/api/search-image?query=cozy%20vintage%20watchmaking%20workbench%20with%20tools%20and%20magnifier%20under%20warm%20lamp%20light%2C%20nostalgic%20artisanal%20atmosphere&width=800&height=600&seq=net-watch-10&orientation=landscape",
    source: "51吃瓜趣闻",
    author: "趣闻小组",
    publishedAt: "2026-10-07 16:30",
    views: 32100,
    tags: ["手艺人", "匠心", "生活趣闻"],
  },
];